import React, { useEffect, useState } from "react";
import { ReactComponent as AddCircle } from "assets/images/svgs/add-circle.svg";
import { useNavigate } from "react-router-dom";
import useAttendee from "containers/attendee/useHooks";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import { siteRoutes } from "utils/helpers/enums/routes";
import MinorCard from "components/cards/minor-card";
import Pagination from "components/pagination";
import { useSelector } from "react-redux";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import minorNotFoundGif from "assets/images/gifs/minor-not-found.gif";

const Minors: React.FC = () => {
  const navigate = useNavigate();
  const { getAttendeeMinors } = useAttendee();
  const [data, setData] = useState<MinorDTO[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [filters, setFilters] = useState<any>({ page: 0, size: 30, totalElements: 0 });

  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, data]);

  const getAllMinors = (currentFilters: any) => {
    const queryParams: any = {};
    for (let key in currentFilters) {
      if (
        currentFilters[key]?.toString() !== undefined &&
        currentFilters[key] !== ""
      ) {
        queryParams[key] = currentFilters[key];
      }
    }
    getAttendeeMinors(setData, queryParams, [], setFilters);
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    getAllMinors(filters);
  }, []);

  const goToAddMinor = () => {
    navigate(`${siteRoutes.familyInformation}`);
  };

  const onDeleteSuccess = (deletedMinorId: number) => {
    // Optimistically remove the deleted minor from local state for instant UI update
    setData((prev) => prev.filter((m) => m.id !== deletedMinorId));
    setFilters((prev: any) => ({ ...prev, totalElements: Math.max((prev?.totalElements || 0) - 1, 0) }));
  };

  const handlePageChange = (pageInfo: { selected: number; limit: number }) => {
    const updated = { ...filters, page: pageInfo.selected, size: pageInfo.limit };
    setFilters(updated);
    getAllMinors(updated);
  };

  return (
    <div className=" min-h-screen">
      <div className=" flex flex-wrap items-center gap-4 py-5">
        {data.map((minor, index) => (
          <MinorCard
            minor={minor}
            key={index}
            onDeleteSuccess={onDeleteSuccess}
          />
        ))}
      </div>
      <div>
        <CustomMessageDisplay
          show={!isLoading && !isInitialLoad && !data.length}
          title="Experiences are Better Together"
          slogan="Don’t go on adventures alone. Add your family members to easily book and enjoy events as a group."
          image={minorNotFoundGif}
          imageAlt="No family members found"
          className="py-16"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>
       {data?.length > 30 && (
        <Pagination
          count={filters.totalElements}
          page={filters.page}
          limit={filters.size}
          onPageChange={handlePageChange}
          activeBgColor={"#DE9C27"}
          activeTextColor={"#ffffff"}
        />
      )}
      <div className="flex justify-center mt-5">
        <button
          className="flex gap-1 bg-borderColor items-center px-4 py-2 rounded-full text-primaryBlueText"
          onClick={goToAddMinor}
        >
          <span>
            <AddCircle />
          </span>
          Add Family Member
        </button>
      </div>
    </div>
  );
};

export default Minors;
